import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntPersonalSettingsIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <g clipPath="url(#clip0_4962_534)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1126 8.776C14.1455 8.52 14.1701 8.264 14.1701 8C14.1701 7.736 14.1455 7.472 14.1126 7.2L15.8479 5.896C16.0042 5.776 16.0453 5.56 15.9466 5.384L14.3017 2.616C14.203 2.44 13.981 2.368 13.8 2.44L11.7522 3.24C11.3245 2.928 10.8804 2.656 10.3622 2.456L10.0579 0.336C10.025 0.144 9.85231 0 9.6467 0H6.35693C6.15132 0 5.97861 0.144 5.94571 0.336L5.64141 2.456C5.12327 2.656 4.67915 2.928 4.25148 3.24L2.2036 2.44C2.02266 2.368 1.8006 2.44 1.70191 2.616L0.0570213 5.384C-0.0498963 5.56 -0.000549715 5.776 0.155714 5.896L1.89107 7.2C1.85817 7.472 1.8335 7.736 1.8335 8C1.8335 8.264 1.85817 8.52 1.89107 8.776L0.155714 10.104C-0.000549715 10.224 -0.0498963 10.44 0.0570213 10.616L1.70191 13.384C1.8006 13.56 2.02266 13.624 2.2036 13.56L4.25148 12.752C4.67915 13.072 5.12327 13.344 5.64141 13.544L5.94571 15.664C5.97861 15.856 6.15132 16 6.35693 16H9.6467C9.85231 16 10.025 15.856 10.0579 15.664L10.3622 13.544C10.8804 13.336 11.3245 13.072 11.7522 12.752L13.8 13.56C13.981 13.624 14.203 13.56 14.3017 13.384L15.9466 10.616C16.0453 10.44 16.0042 10.224 15.8479 10.104L14.1126 8.776ZM10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6ZM8 12C9.62284 12 11.02 11.0336 11.6472 9.64486C11.02 8.96979 9.62284 8.5 8 8.5C6.37716 8.5 4.98005 8.96979 4.35277 9.64486C4.98005 11.0336 6.37716 12 8 12Z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4962_534">
          <rect width="16" height="16" fill="white"></rect>
        </clipPath>
      </defs>
    </SntIcon>
  );
};

export default SntPersonalSettingsIcon;
